import React from 'react';

const RULES = [
  'No hate or slurs.',
  'No self-harm encouragement.',
  'No personal attacks.',
  'No sexual content involving minors.',
  'No doxxing or private info.',
  'No harassment or threats.',
];

export default function CommunityRulesPanel({ title = 'Community Rules', compact = false, className = '' }) {
  return (
    <div className={`rounded-xl border border-slate-700 bg-slate-800/60 ${compact ? 'p-3' : 'p-4'} ${className}`.trim()}>
      <div className={`font-semibold text-slate-100 ${compact ? 'text-xs' : 'text-sm'} mb-2`}>{title}</div>
      <ul className={`space-y-1 text-slate-300 ${compact ? 'text-[11px]' : 'text-xs'}`}>
        {RULES.map((rule) => (
          <li key={rule} className="flex items-start gap-2">
            <span className="text-slate-500">•</span>
            <span>{rule}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
